/* Keep the shared Shopify language choice when entering GrowJoy from an unprefixed link. */
(function () {
  'use strict';
  var key = 'growjoy-selected-locale-v1';
  function normalise(code) {
    code = String(code || '').toLowerCase();
    return code === 'ms' ? 'ms' : code.indexOf('zh') === 0 ? 'zh' : code === 'en' ? 'en' : '';
  }
  function save(code) {
    code = normalise(code);
    if (code) try { localStorage.setItem(key, code); } catch (_) {}
  }
  var pathname = location.pathname;
  // A shared locale URL is not a language choice. Remember only button clicks.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[name="language_code"]');
    if (button && button.form && button.form.action.indexOf('/localization') !== -1) save(button.value);
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.action && event.target.action.indexOf('/localization') !== -1 && event.submitter) save(event.submitter.value);
  }, true);
  if (window.Shopify && window.Shopify.designMode) return;
  if (/^\/pages\/kids(?=[\/-]|$)/i.test(pathname)) {
    var preferred = '';
    try { preferred = normalise(localStorage.getItem(key)); } catch (_) {}
    if (preferred && preferred !== 'en') location.replace('/' + preferred + pathname + location.search + location.hash);
  }
})();
